var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "3bb71f8fa2d8865366c60eb6dfe50924aead0ba1"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["foundation@mdrt"] = {
  id: "3bb71f8fa2d8865366c60eb6dfe50924aead0ba1"
};